export default __webpack_public_path__ + "static/media/admin_site_logo.160a6e59.png";